import { enableProdMode, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { provideServiceWorker } from '@angular/service-worker';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CanDeactivateGuard } from './app/_guards/can-deactivate.guard';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { cookieAuthInterceptorInterceptor } from './app/_helpers/cookie-auth-interceptor.interceptor';
import { errorInterceptor } from './app/_helpers/error.interceptor';
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(
      BrowserModule,
      LayoutModule,
      FormsModule,
      ReactiveFormsModule,
      AppRoutingModule,
      MatSliderModule,
      MatIconModule,
      MatSlideToggleModule,
      MatButtonToggleModule,
      MatExpansionModule,
      MatButtonModule,
      MatFormFieldModule,
      MatInputModule,
      MatTooltipModule,
      MatSelectModule,
      MatAutocompleteModule,
      MatMenuModule,
    ),
    CanDeactivateGuard,
    provideHttpClient(
      withInterceptors([cookieAuthInterceptorInterceptor, errorInterceptor]),
    ),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch((err) => console.error(err));
